import { makeStyles, withTheme } from "@material-ui/core/styles";
import Image from "./image/1280x720.webp";

export default makeStyles((theme) => ({
  "@global": {
    body: {
      backgroundImage: `url(${Image})`,
      color: "white",
      backgroundSize: "cover",
    },
  },
  appBar: {
    margin: "30px 0",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "hsla(240, 100%, 56%, 0.65)",
    borderBottomLeftRadius: 20,
    borderBottomRightRadius: 20,
  },
  heading: {
    color: "yellow",
    opacity: 0.8,
    "@media (max-width:600px)": {
      fontSize: "2.2rem",
      marginLeft: "25",
    },
  },
  heading6: {
    fontSize: 16,
    marginTop: 22,
    marginLeft: 5,
    "@media (max-width:600px)": {
      fontSize: ".8rem",
      marginTop: 15,
    },
    "@media (max-width:360px)": {
      fontSize: ".5rem",
    },
    color: "yellow",
  },
  heading4: {
    fontSize: 16,
    marginTop: 7,
    marginLeft: 5,
    "@media (max-width:600px)": {
      fontSize: ".8rem",
    },
    "@media (max-width:360px)": {
      fontSize: ".5rem",
    },
    color: "gray",
  },
  heading5: {
    fontSize: 16,
    marginTop: 22,
    "@media (max-width:600px)": {
      fontSize: ".9rem",
    },
    "@media (max-width:360px)": {
      fontSize: ".75rem",
    },
    color: "white",
    fontWeight: "bold",
  },
  image: {
    marginLeft: "15px",
  },
  [theme.breakpoints.down("sm")]: {
    mainContainer: {
      flexDirection: "column-reverse",
      overflowX: "hidden",
    },
  },
  footer: {
    textAlign: "center",
    padding: "0",
    height: "40px",
    width: "30%",
    marginTop: "30px",
    marginInline: 0,
    boxSizing: "border-box",
    margin: "auto",
    marginInline: "auto",
    marginBottom: "10px",
  },
}));